import { generateQueryKey } from 'query';
import type { ChannelEntityType } from '../types';

export const getChannelsFeatureQueryKey = () => generateQueryKey(['channels']);

export const getChannelsQueryKey = (params: { organizationId?: string; pageSize?: number }) =>
  generateQueryKey([...getChannelsFeatureQueryKey(), params]);

export const getChannelEntitiesQueryKey = (params: {
  channelId?: string;
  featured?: boolean;
  pageSize?: number;
  subject?: ChannelEntityType;
}) => generateQueryKey([...getChannelsFeatureQueryKey(), 'entities', params]);

export const getChannelDetailQueryKey = (params: { channelId?: string }) =>
  generateQueryKey([...getChannelsFeatureQueryKey(), 'detail', params]);
